<template>
<div>
    <!-- Broker List -->
    <v-card class="ma-5 px-5">
        <v-card-title>
            <div class="text-h4 primary--text font-weight-light">Broker-Dealers</div>
            <span v-if="brokerListLoading" class="text-h4 text-center primary--text font-weight-light">
                : Loading
                <v-progress-circular indeterminate color="primary" class="ml-2" v-on="on"></v-progress-circular>    
            </span>
        </v-card-title>
        <v-card-text class="card">
            <v-row v-for="broker in brokerList"
            :key="broker.id"
            class="list-item"
            @click="selectBrokerFromList(broker)">
                <v-col class="py-0">
                    <v-row :id="broker.broker_id">
                        <v-col cols="12" style="font-size:18px;">
                            {{broker.broker_dealer_name}}
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row></v-row>
        </v-card-text>
        <v-card-actions>
            <v-tooltip top>
                <template v-slot:activator="{ on }">
                    <v-btn
                    large
                    color="green lighten-2"
                    dark
                    class="ma-2"
                    v-on="on"
                    elevation=0
                    @click="newBrokerButton"
                    >
                    Add New Broker Dealer
                    </v-btn>
                </template>
                <span>Create a new Broker Dealer</span>
            </v-tooltip>
        </v-card-actions>
    </v-card>

    <!-- Broker Form -->
    <div class="mx-5">   
        <v-card class="custom-card" outlined>
            <v-col class="ml-5">
                <div class="text-h4 primary--text font-weight-light">
                    {{brokerFormTitle}}
                    <span v-if="brokerHasChanges" class="warn">Changes are not saved!</span>
                </div>
            </v-col>
            <v-col cols="12" class="pb-0">
                <v-container class="pb-0">
                    <v-row no-gutters>
                        <v-col cols="6" class="px-5">
                            <v-text-field 
                                v-model="brokerSelected.broker_dealer_name"
                                :error-messages="brokerNameErrors"
                                label="* Name"
                                class="pa-0 ma-0"
                                required
                                @change="brokerHasChanges = true">
                            </v-text-field>
                        </v-col>
                        <v-col cols="6" class="px-5">
                            <v-text-field 
                                v-model="brokerSelected.firm_address"
                                label="Firm Address"
                                class="pa-0 ma-0"
                                @change="brokerHasChanges = true">
                            </v-text-field>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3" class="px-5">
                            <v-text-field 
                                v-model="brokerSelected.firm_city"
                                label="City"
                                class="pa-0 ma-0"
                                @change="brokerHasChanges = true">
                            </v-text-field>
                        </v-col>
                        <v-col cols="3" class="px-5">
                            <v-text-field 
                                v-model="brokerSelected.firm_state"
                                label="State"
                                class="pa-0 ma-0"
                                @change="brokerHasChanges = true">
                            </v-text-field>
                        </v-col>
                        <v-col cols="3" class="px-5">
                            <v-text-field 
                                v-model="brokerSelected.firm_zip"
                                label="ZIP Code"
                                class="pa-0 ma-0"
                                @change="brokerHasChanges = true">
                            </v-text-field>
                        </v-col>
                        <v-col cols="3" class="px-5" style="text-align:end;">
                            <v-btn color="primary" dark @click="submitBrokerForm">Save Changes</v-btn>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-card>
    </div>
    <div style="min-height:200px;"></div>
</div>
  
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { BrokerDealer } from '@/store/modules/dataModels.js';

  export default {
    data: () => ({
        on: null,
        modes: {
            EDIT: 'edit',
            CREATE: 'create',
            DISABLE: 'disable',
        },
        brokerSelected: new BrokerDealer(),
        brokerHasChanges: false,
        brokerFormSubmitting: false,
        brokerMode: null
    }),

    mounted() {
        this.brokerSelected = new BrokerDealer();
        this.adminGetBrokerList();
    },

    computed: {
        ...mapGetters({ 
            brokerList: 'getSiteAdminBrokerList',
        }),

        brokerListLoading(){
            if (this.brokerList.length === 0 || this.brokerFormSubmitting) {
                return true;
            }
            return false;
        },
        
        brokerFormTitle(){
            if (this.brokerMode === this.modes.EDIT){
                return `Edit: ${this.brokerSelected.broker_dealer_name}`
            } else {
                return "Add New Broker Dealer"
            }
        },

        brokerNameErrors () {
            if (!this.brokerFormSubmitting) return [];
            const errors = [];
            if (this.brokerSelected.broker_dealer_name === null || this.brokerSelected.broker_dealer_name === "") {
                errors.push("Required");
            }
            return errors;
        },
    },

    methods: {
        ...mapActions([
            'adminCreateBroker',
            'adminUpdateBroker',
            'adminGetBrokerList',
            ]),

        selectBrokerFromList(broker){
            this.brokerHasChanges = false;
            this.brokerFormSubmitting = false;
            this.brokerMode = this.modes.EDIT;
            this.brokerSelected = broker;
            this.changeSelectedElement(broker.broker_id,'broker');
        },

        newBrokerButton(){
            this.brokerHasChanges = false;
            this.brokerFormSubmitting = false;
            this.brokerMode = this.modes.CREATE
            this.brokerSelected = new BrokerDealer();
            this.changeSelectedElement(null,'broker');
        },

        submitBrokerForm(){
            this.brokerFormSubmitting = true;
            if (this.brokerFormHasErrors()) return;
            if (this.brokerMode === this.modes.CREATE){
                this.adminCreateBroker(this.brokerSelected)
                this.brokerHasChanges = false;
            } else if (this.brokerMode === this.modes.EDIT) {
                this.adminUpdateBroker(this.brokerSelected);
                this.brokerHasChanges = false;
                this.changeSelectedElement(this.brokerSelected.broker_id,'broker');
            }
            this.brokerFormSubmitting = false;
        },

        brokerFormHasErrors(){
            let hasErrors = false;
            let attrs = [this.brokerSelected.broker_dealer_name];
            attrs.forEach((attr) => {
                if (attr === null || attr === 'undefined' || attr === "") hasErrors = true;
            })
            return hasErrors;
        },

        changeSelectedElement(id,list){
            let eles = document.querySelectorAll(`.selected-${list}`)
            eles.forEach((e) => {
                e.classList.remove(`selected-${list}`);
                })
            if (id) {
                let ele = document.getElementById(id)
                ele.classList.add(`selected-${list}`)
            }
        },
    },
    components: { },
  };
</script>

<style scoped>
.list-item {
    cursor: pointer;
}
.list-item:hover {
    background-color: rgb(210, 230, 255)
}
.selected-broker {
    border:1px solid blue;
    border-radius:4px;
}
.warn {
    font-size: 16px;
    color: rgb(250, 100, 50);
}
.card {
    max-height:300px;
    min-height:300px;
    overflow-y:scroll;
    overflow-x:hidden;
    border:1px solid #ddd;
    border-radius: 5px;
}
</style>
